import axios from 'axios';

// API Base URL - yeni domain
const API_BASE_URL = 'https://isiltisazevi.com/adminnn/api';

// Axios instance oluştur
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 saniye timeout - fazla ürün için
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  // Retry configuration
  retry: 3,
  retryDelay: 1000,
});

// Response interceptor - API yanıtlarını işle
api.interceptors.response.use(
  (response) => {
    // Check if response is valid JSON
    if (typeof response.data === 'string') {
      try {
        return JSON.parse(response.data);
      } catch (e) {
        console.error('JSON Parse Error:', e);
        console.error('Raw Response:', response.data);
        throw new Error('Invalid JSON response from server');
      }
    }
    return response.data;
  },
  (error) => {
    console.error('API Error:', error);
    
    if (error.response) {
      console.error('Server Error:', error.response.status);
      console.error('Response Data:', error.response.data);
      console.error('Response Headers:', error.response.headers);
    } else if (error.request) {
      console.error('Network Error: No response received');
      console.error('Request Config:', error.config);
    } else {
      console.error('Request Setup Error:', error.message);
    }
    
    return Promise.reject(error);
  }
);

// API Service Functions
export const apiService = {
  // Kategoriler
  getCategories: async (params = {}) => {
    try {
      const response = await api.get('/categories_simple.php', { params });
      return response;
    } catch (error) {
      console.error('Kategoriler API hatası:', error);
      throw new Error('Kategoriler yüklenirken hata oluştu');
    }
  },

  // Ana kategoriler
  getMainCategories: async (params = {}) => {
    try {
      // Cache bypass için timestamp ekle
      const paramsWithCache = { ...params, t: Date.now() };
      const response = await api.get('/categories_fresh.php', { params: paramsWithCache });
      return response;
    } catch (error) {
      console.error('Ana kategoriler API hatası:', error);
      throw new Error('Ana kategoriler yüklenirken hata oluştu');
    }
  },

  // Alt kategoriler
  getSubcategories: async (params = {}) => {
    try {
      // Cache bypass için timestamp ekle
      const paramsWithCache = { ...params, t: Date.now() };
      // Ana kategoriler API'sini kullan - zaten alt kategoriler de geliyor
      const response = await api.get('/categories_fresh.php', { params: paramsWithCache });
      return response;
    } catch (error) {
      console.error('Alt kategoriler API hatası:', error);
      throw new Error('Alt kategoriler yüklenirken hata oluştu');
    }
  },

  getCategoryById: async (id) => {
    try {
      const response = await api.get(`/categories.php?id=${id}`);
      return response;
    } catch (error) {
      throw new Error('Kategori bilgileri yüklenirken hata oluştu');
    }
  },

  // Ürünler
  getProducts: async (params = {}) => {
    try {
      // Cache bypass için timestamp ekle
      const paramsWithCache = { ...params, t: Date.now() };
      const response = await api.get('/products_simple.php', { params: paramsWithCache });
      console.log('Products API response:', response);
      return response;
    } catch (error) {
      console.error('Ürünler API hatası:', error);
      throw new Error('Ürünler yüklenirken hata oluştu');
    }
  },

  getProductById: async (id) => {
    try {
      const response = await api.get(`/products_working.php?id=${id}`);
      return response;
    } catch (error) {
      console.error('Ürün detay API hatası:', error);
      throw new Error('Ürün bilgileri yüklenirken hata oluştu');
    }
  },

  // Ürün arama
  searchProducts: async (searchTerm, params = {}) => {
    try {
      const response = await api.get('/products_working.php', { 
        params: { 
          search: searchTerm,
          ...params 
        } 
      });
      return response;
    } catch (error) {
      throw new Error('Arama yapılırken hata oluştu');
    }
  },

  // Kategoriye göre ürünler
  getProductsByCategory: async (categoryId, params = {}) => {
    try {
      const response = await api.get('/products_working.php', { 
        params: { 
          category_id: categoryId,
          ...params 
        } 
      });
      return response;
    } catch (error) {
      throw new Error('Kategori ürünleri yüklenirken hata oluştu');
    }
  },

  // Ana kategoriye göre ürünler
  getProductsByMainCategory: async (mainCategoryId, params = {}) => {
    try {
      const response = await api.get('/products_working.php', { 
        params: { 
          main_category_id: mainCategoryId,
          ...params 
        } 
      });
      return response;
    } catch (error) {
      throw new Error('Ana kategori ürünleri yüklenirken hata oluştu');
    }
  },

  // Öne çıkan ürünler
  getFeaturedProducts: async (params = {}) => {
    try {
      const response = await api.get('/products_simple.php', { 
        params: { 
          featured: '1',
          ...params 
        } 
      });
      console.log('Featured products API response:', response);
      return response;
    } catch (error) {
      console.error('Öne çıkan ürünler API hatası:', error);
      throw new Error('Öne çıkan ürünler yüklenirken hata oluştu');
    }
  },

  // Galeri fotoğrafları
  getGalleryImages: async () => {
    try {
      const response = await api.get('/gallery.php');
      return response;
    } catch (error) {
      console.error('Galeri fotoğrafları API hatası:', error);
      throw new Error('Galeri fotoğrafları yüklenirken hata oluştu');
    }
  }
};

export default api;
